import { ServiceIdentifier } from '../service-locator';
import { StatusService } from './interfaces';

export * from './interfaces';

/**
 * The service locator identifier for the SettingsService
 */
export const STATUS_SERVICE = ServiceIdentifier.get<StatusService>('StatusService');
